"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_loader_1 = __importDefault(require("react-loader"));
const Defaults_1 = require("../../common/Defaults");
const moment_1 = __importDefault(require("moment"));
const hui_1 = require("@mit/hui");
const MedicalApi_1 = __importDefault(require("../../api/MedicalApi"));
const DownloadBetweenDates = ({ hideModalCallback, show, onClose }) => {
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const [startDate, setStartDate] = (0, react_1.useState)((0, moment_1.default)());
    const [endDate, setEndDate] = (0, react_1.useState)((0, moment_1.default)());
    const handleClose = () => {
        if (hideModalCallback)
            hideModalCallback();
        if (onClose)
            onClose();
    };
    const submitAndClose = () => __awaiter(void 0, void 0, void 0, function* () {
        setIsLoading(true);
        let resp = yield handleFileDownload(startDate, endDate);
        setIsLoading(false);
        handleClose();
    });
    const changeStartDate = (newValue) => {
        setStartDate((0, moment_1.default)(newValue.startDate));
    };
    const changeEndDate = (newValue) => {
        setEndDate((0, moment_1.default)(newValue.endDate));
    };
    const changeDateRange = (newValue) => {
        if (newValue.from !== undefined) {
            let fromDate = new Date(newValue.from.year, newValue.from.month - 1, newValue.from.day);
            setStartDate((0, moment_1.default)(fromDate));
        }
        if (newValue.to !== undefined) {
            let toDate = new Date(newValue.to.year, newValue.to.month - 1, newValue.to.day);
            setEndDate((0, moment_1.default)(toDate));
        }
    };
    const handleFileDownload = (from, to) => __awaiter(void 0, void 0, void 0, function* () {
        const fileDataResp = yield MedicalApi_1.default.downloadManifest(from, to);
        setIsLoading(true);
        if (!fileDataResp.error) {
            let stringData = fileDataResp.data ? fileDataResp.data : '';
            const element = document.createElement("a");
            const file = new Blob([stringData], { type: 'text/csv' });
            element.href = URL.createObjectURL(file);
            element.download = `completed-tests.csv`;
            document.body.appendChild(element); // Required for this to work in FireFox
            element.click();
            setIsLoading(false);
            handleClose();
        }
        else {
            alert('An error occurred and the file could not be downloaded.');
            setIsLoading(false);
        }
    });
    const toDate = new Date();
    let fromDate = new Date();
    fromDate.setDate(fromDate.getDate() - 7);
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)(hui_1.Drawer, { contentAriaLabel: `Download Between Dates`, footer: [], show: show, onClose: onClose, header: (0, jsx_runtime_1.jsx)(hui_1.Text, { content: "Download Between Dates", type: hui_1.TextType.Heading3, icon: "" }), size: hui_1.DrawerSize.Medium, type: hui_1.DrawerType.Right, themedColor: "medical", contents: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(react_loader_1.default, Object.assign({ loaded: !isLoading, options: Object.assign(Object.assign({}, Defaults_1.mediumLoaderOptions), { color: '#000000' }) }, { children: (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "text-center" }, { children: (0, jsx_runtime_1.jsx)(hui_1.CalendarInput, { id: "downloadRange", isRangeSelected: true, onChange: changeDateRange, placeholder: "Select a date range", value: {
                                    from: { day: fromDate.getDate(), month: fromDate.getMonth() + 1, year: fromDate.getFullYear() },
                                    to: { day: toDate.getDate(), month: toDate.getMonth() + 1, year: toDate.getFullYear() }
                                } }) })) })), (0, jsx_runtime_1.jsx)("br", {}), (0, jsx_runtime_1.jsx)(hui_1.ButtonBar, { type: hui_1.ButtonBarType.Padded, buttons: [
                            {
                                icon: '',
                                text: "Download",
                                state: isLoading ? hui_1.ButtonState.Disabled : hui_1.ButtonState.Enabled,
                                type: hui_1.ButtonType.Primary,
                                onClick: submitAndClose,
                            },
                            // {
                            //     icon: '',
                            //     text: "Download All",
                            //     state: isLoading? ButtonState.Disabled : ButtonState.Enabled,
                            //     type: ButtonType.Primary,
                            //     onClick: handleFileDownload,
                            // },
                            {
                                icon: '',
                                text: "Cancel",
                                state: isLoading ? hui_1.ButtonState.Disabled : hui_1.ButtonState.Enabled,
                                type: hui_1.ButtonType.Secondary | hui_1.ButtonType.Ghost,
                                onClick: handleClose,
                            }
                        ] })] }) }) }));
};
exports.default = DownloadBetweenDates;
